import { Component, OnInit, Input, AfterContentInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
/* Validators */
import { EmailValidator } from 'src/app/validators/email/email-validator';
import { PasswordValidator } from 'src/app/validators/password/password-validator';
import { NotAdultValidator } from 'src/app/validators/notadult/notadult-validator';
/* Models */
import { RegisterUserModel, RegisterErrorModel } from 'src/app/models/registeruser.model';
import { Country, State } from 'src/app/models/userdetails.model';
/* Templates */
import { TerminsOfServiceTemplateSheetComponent } from 'src/app/tools/templatesheets/terms-of-service-template-sheet/terms-of-service-template-sheet.component';
import { TerminsAndConditionsTemplateSheetComponent } from 'src/app/tools/templatesheets/termins-and-conditions-template-sheet/termins-and-conditions-template-sheet.component';
import { PrivatePolicyTemplateSheetComponent } from 'src/app/tools/templatesheets/private-policy-template-sheet/private-policy-template-sheet.component';
/* Material */
import { MatBottomSheet } from '@angular/material/bottom-sheet';
/* Packages */
import { Subscription, Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
/* Services */
import { AuthService } from 'src/app/services/auth/auth.service';
import { ClientService } from 'src/app/services/client/client.service';
import { UserService } from 'src/app/services/user/user.service';
import { LottosService } from 'src/app/services/lottos/lottos.service';
import { DialcodeService } from 'src/app/services/dialcode/dialcode.service';
import { StateService } from 'src/app/services/state/state.service';
import { SignonService } from 'src/app/services/signon/signon.service';
/* Global configs */
import { environment } from 'src/environments/environment';
import { RedirectToMainSiteService } from 'src/app/services/redirectToMainSite/redirect-to-main-site.service';
import { StoragePermissionService } from 'src/app/services/storagePermission/storage-permission.service';
import { Router } from '@angular/router';
import { WindorefService } from 'src/app/services/window/windoref.service';
import { Language } from '../language/language';
import { MatDialog } from '@angular/material/dialog';
import { ModalAcceptsTermsComponent } from 'src/app/components/modal-accepts-terms/modal-accepts-terms.component';

/* Todo: integrate this with Abstract Controls */
const EMAIL_REGEXP: any = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})$/;
const accentedCharacters = 'àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ';
const stringRegex = '^[a-zA-Z' + accentedCharacters + '\\s]+$';
const ADDRESS_PATTERN = /^(?!.*[!@#$%^&*()\-_+={}[\]|\\;:'",<.>\/?]{2}).+$/;
const NAME_PATTERN = /^(?!.*[0-9!@#$%^&*()\-_+={}[\]|\\;:'",<.>\/?]).+$/;
const PASSWORD_REGEX = /^[a-zA-Z0-9\.\-_!?*\/]+$/;

@Component({
  selector: 'app-login',
  templateUrl: './login.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterContentInit {
  @Input() state: boolean;
  registerForm: FormGroup;

  /* Animation Variables */
  showForm: boolean = true;
  signInUpText: string;
  signInUpState: boolean;
  isHide: boolean = true;
  forgotPass: boolean = false;
  isStep: boolean = false;
  loading: boolean = false;

  /* Error Variables */
  error: boolean = false;
  errorMailExist: boolean;
  errorFormInvalid: boolean = false;
  errorCredentials: boolean;
  errorRecovery: boolean;
  errorCpfInvalid: boolean;
  errorNumberPhone: boolean;
  errorInvalidState: boolean;

  /* Country & State Variables */
  countries: Country[] = [];
  birth_countries: Country[] = [];
  country: Country = null;
  birth_country: Country = null;
  filteredCountries: Observable<Country[]>;
  filteredBirthCountries: Observable<Country[]>;
  arrCountries: any;
  arrBirth_Countries: any;
  dialcode: any = { isValid: false };
  states: State[] = [];
  filteredStates: Observable<State[]>;
  showState: boolean = false;
  ssnOptions: any;
  filteredOptions: Observable<any[]>;

  /* Lotto Variables */
  lottoSubs: Subscription;

  /* General Variables */
  title: string;
  sys: string;
  user: RegisterUserModel;
  lottoId = environment.lottery.lot_id;
  isSubmit = false;
  acceptTerms = false;
  public lang: any = Language.currentLanguage.lenid;

  constructor(
    private _sheet: MatBottomSheet,
    private formBuilder: FormBuilder,
    private clientService: ClientService,
    private dialcodeService: DialcodeService,
    private lotto: LottosService,
    private _state: StateService,
    private _user: UserService,
    private _signOnService: SignonService,
    private redirectSrv: RedirectToMainSiteService,
    private _storageService: StoragePermissionService,
    public dialog: MatDialog,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.setSysAndLang();
  }

  ngAfterContentInit(): void {
    this.clientService.getCountries().subscribe((countries: any) => {
      this.countries = countries.data;
      this.birth_countries = countries.data;
    });
    this.getDocumentType();
    this.filterCountry();
    this.filterBirthCountry();
    this.dialcodeService.getDialcode();
  }

  setSysAndLang(): void {
    this.lottoSubs = this.lotto.lottoObservable$.subscribe((lottoObj) => {
      this.sys = lottoObj['system'];
    });
  }

  buildForm() {
    this.registerForm = this.formBuilder.group(
      {
        email: new FormControl('', [Validators.email, Validators.required, Validators.pattern(EMAIL_REGEXP)]),
        password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_REGEX), Validators.minLength(8)]),
        name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.pattern(NAME_PATTERN), Validators.maxLength(25)]),
        last_name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.pattern(NAME_PATTERN), Validators.maxLength(25)]),
        phone: new FormControl('', [Validators.pattern('[0-9]+'), Validators.maxLength(15)]),
        country: new FormControl(null, [Validators.pattern(stringRegex)]),
        country_birth: new FormControl(null, [Validators.pattern(stringRegex)]),
        address1: new FormControl(null, [Validators.required, Validators.pattern(ADDRESS_PATTERN)]),
        city: new FormControl(null, [Validators.required, Validators.pattern(ADDRESS_PATTERN)]),
        zipcode: new FormControl('', [Validators.required]),
        birthdate: new FormControl(null, [Validators.required]),
        ssn: new FormControl(null, [Validators.required])
      },
      {
        validator: [NotAdultValidator.NotAdult]
      }
    );
  }

  registerUser(): void {
    if (!this.acceptTerms) {
      this.openModalInformation();
    } else {
      this.loading = true;
      let data = this.registerForm.value;
      if (this.country?.iso !== 'BR') {
        const dataBasic = {
          email: this.registerForm.get('email').value,
          password: this.registerForm.get('password').value,
          name: this.registerForm.get('name').value,
          last_name: this.registerForm.get('last_name').value,
          phone: this.registerForm.get('phone').value,
          country: this.registerForm.get('country').value,
          country_birth: this.registerForm.get('country_birth').value,
          birthdate: this.registerForm.get('birthdate').value,
          address1: this.registerForm.get('address1').value,
          city: this.registerForm.get('city').value,
          zipcode: this.registerForm.get('zipcode').value,
          ssn: this.registerForm.get('ssn').value
        };

        if (this.showState) {
          data = {
            state: this.registerForm.get('state').value,
            ...dataBasic
          };
        } else {
          data = {
            ...dataBasic
          };
        }

        if (this.country?.iso === 'CO') {
          const typeDocument = this.ssnOptions.find((c) => c.name === this.registerForm.get('ssn_type').value);
          data = {
            ssn_type: typeDocument ? typeDocument.id : this.ssnOptions[0].id,
            ...data
          };
        }
      }
      this.user = this._user.getUserData(data, this.getCallCode(), this.getCountryID(), this.getBirthCountryID(), this.getStateID());
      if (this.registerForm.valid) {
        this.makeResgisterUser();
      } else {
        this.loading = !this.loading;
        this.errorFormInvalid = true;
      }
    }
  }

  openModalInformation(): void {
    this.dialog.open(ModalAcceptsTermsComponent, {
      disableClose: true,
      width: '450px',
      data: { id: 0 }
    });
  }

  getCountryID(): number {
    let country: string = this.registerForm.get('country').value;

    return this.countries.find((c) => c.name.toLowerCase() == this.removeAccents(country))?.identifier;
  }

  getBirthCountryID(): number {
    let country: string = this.registerForm.get('country_birth').value;

    return this.birth_countries.find((c) => c.name.toLowerCase() == this.removeAccents(country))?.identifier;
  }

  getStateID(): number {
    if (!this._state.countryHasState()) return 0;

    let state: string = this.registerForm.get('state').value;
    return this.states.find((s) => this.removeAccents(s.name) === this.removeAccents(state))?.identifier;
  }

  getCallCode(): string {
    return this.dialcode.callingCodes ? this.dialcode.callingCodes[0] : '';
  }

  getCountry(country = null) {
    if (country) {
      this.country = country;
    } else {
      let country: string = this.registerForm.get('country').value;
      this.country = this.countries.find((c) => c.name.toLowerCase() === this.removeAccents(country));
    }
    if (this.country) {
      if (this.country?.iso === 'BR') {
        this.registerForm.controls['ssn'].setValidators(Validators.required);
        // Remover ssn_type si existe
        if (this.registerForm.get('ssn_type')) {
          this.registerForm.removeControl('ssn_type');
        }
        this.filteredOptions = null;
      } else if (this.country?.iso === 'CO') {
        this.registerForm.controls['ssn'].setValidators(Validators.required);
        // Agregar ssn_type si no existe
        if (!this.registerForm.get('ssn_type')) {
          this.registerForm.addControl('ssn_type', this.formBuilder.control('', [Validators.required]));
        } else {
          this.registerForm.controls['ssn_type'].setValidators(Validators.required);
        }
        this.filterSsnType();
      } else {
        // Remover ssn_type si existe para otros países
        if (this.registerForm.get('ssn_type')) {
          this.registerForm.removeControl('ssn_type');
        }
        this.filteredOptions = null;
      }
      this.registerForm.controls['ssn'].updateValueAndValidity();
      if (this.registerForm.get('ssn_type')) {
        this.registerForm.controls['ssn_type'].updateValueAndValidity();
      }
    }
  }

  getBirthCountry(country = null) {
    if (country) {
      this.birth_country = country;
    } else {
      let country: string = this.registerForm.get('country_birth').value;
      this.birth_country = this.birth_countries.find((c) => c.name.toLowerCase() === this.removeAccents(country));
    }
  }

  getSSNOption(type = null) {
    if (type) {
      this.ssnOptions = type;
    } else {
      this.getDocumentType();
    }
  }

  changeStep($event: any) {
    if (
      this.registerForm.controls['name'].invalid ||
      this.registerForm.controls['email'].invalid ||
      this.registerForm.controls['password'].invalid ||
      this.registerForm.controls['country'].invalid ||
      this.registerForm.controls['country_birth'].invalid ||
      this.registerForm.controls['birthdate'].invalid ||
      this.registerForm.controls['phone'].invalid ||
      this.registerForm.controls['address1'].invalid ||
      this.registerForm.controls['zipcode'].invalid ||
      this.registerForm.controls['ssn'].invalid ||
      this.registerForm.controls['city'].invalid ||
      (this.country && this.country?.iso === 'CO' && this.registerForm.get('ssn_type') && this.registerForm.controls['ssn_type'].invalid)
    ) {
      this.error = true;
    } else {
      $event.preventDefault();
      this.resetFlats();
      this.error = false;
      this.isStep = !this.isStep;
      this.registerUser();
    }
  }

  get setTitle() {
    return this.state ? (this.title = 'LOGIN.PLACEHOLDER.WELCOMEBACK') : (this.title = 'LOGIN.PLACEHOLDER.WELCOMESINGUP');
  }

  showPassword(): void {
    this.isHide = !this.isHide;
  }

  changeState($event: any): void {
    $event.preventDefault();
    this.state = !this.state;
  }

  getDocumentType() {
    this.authService.getInfoStoreUsers().subscribe((res: any) => {
      this.ssnOptions = res.data.document_type_colombian;
    });
  }

  filterCountry() {
    this.filteredCountries = this.registerForm.get('country').valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }

  filterBirthCountry() {
    this.filteredBirthCountries = this.registerForm.get('country_birth').valueChanges.pipe(
      startWith(''),
      map((value) => this._filterBirth(value))
    );
  }

  filterSsnType() {
    if (this.country?.iso === 'CO' && this.registerForm.get('ssn_type')) {
      this.filteredOptions = this.registerForm.get('ssn_type').valueChanges.pipe(
        startWith(''),
        map((value) => this._filterSsnType(value))
      );
    } else {
      // Clear the filtered options when not Colombia
      this.filteredOptions = null;
    }
  }

  private _filter(value: Country | string): Country[] {
    if (value && typeof value === 'object') {
      const filterValue = value.name.toLowerCase();
      return this.countries.filter((country) => country.name.toLowerCase().includes(filterValue));
    }
    if (value && typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.countries.filter((country) => country.name.toLowerCase().includes(filterValue));
    }
    if (value === '') {
      return this.countries;
    }
  }

  private _filterBirth(value: Country | string): Country[] {
    if (value && typeof value === 'object') {
      const filterValue = value.name.toLowerCase();
      return this.birth_countries.filter((country) => country.name.toLowerCase().includes(filterValue));
    }
    if (value && typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.birth_countries.filter((country) => country.name.toLowerCase().includes(filterValue));
    }
    if (value === '') {
      return this.birth_countries;
    }
  }

  private _filterSsnType(value: any): any[] {
    if (!this.ssnOptions || !Array.isArray(this.ssnOptions)) {
      return [];
    }

    if (value && typeof value === 'object') {
      const filterValue = value.name.toLowerCase();
      return this.ssnOptions.filter((ssnType) => ssnType.name.toLowerCase().includes(filterValue));
    }
    if (value && typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.ssnOptions.filter((ssnType) => ssnType.name.toLowerCase().includes(filterValue));
    }
    if (value === '') {
      return this.ssnOptions;
    }
    return [];
  }

  filterState() {
    if (this._availableCountry) {
      this.filteredStates = this.registerForm.get('state').valueChanges.pipe(
        startWith(''),
        map((value) => this._filterState(value))
      );
    }
  }

  onValidator(fieldTag: string, validatorTag: string) {
    const field = this.registerForm.controls[fieldTag];
    return field.errors && field.errors[validatorTag] && (this.isSubmit || field.touched);
  }

  private _filterState(value: State | string): State[] {
    if (value && typeof value == 'object') {
      const filterValue = value.name.toLowerCase();
      return this.states.filter((state) => state.name.toLowerCase().includes(filterValue));
    }
    if (value && typeof value == 'string') {
      const filterValue = value.toLowerCase();
      return this.states.filter((state) => state.name.toLowerCase().includes(filterValue));
    }
    if (value == '') {
      return this.states || [];
    }
  }

  setDialCode(): void {
    if (this._availableCountry()) {
      let country: string = this.registerForm.get('country').value;
      let countryISO = this.countries.find((c) => c.name.toLowerCase() == this.removeAccents(country))?.iso;
      this.dialcodeService.setDialCode(countryISO);
      this.dialcodeService.dialCodeObservable$.subscribe((res: any) => {
        if (typeof res === 'object') {
          this.dialcode = { ...res, isValid: true };
        }
      });
    }
  }

  countryControls(): void {
    // this._checkStateValue();
    this._availableBirthCountry();
    this._availableSSNType();
    if (this._availableCountry()) {
      let country: string = this.registerForm.get('country').value;
      let countryCode = this.countries.find((c) => c.name.toLowerCase() === this.removeAccents(country))?.identifier;
      this._state.countryID = countryCode;
      if (this._state.countryHasState()) {
        this.registerForm.addControl('state', this.formBuilder.control('', [Validators.required, Validators.pattern(stringRegex)]));
        this.filterState();
        this._state.getStates().subscribe((res: any) => {
          this._showDataState(res.data);
        });
      } else {
        this._removeStateInput();
      }
    } else {
      this._removeStateInput();
    }
  }

  private _showDataState(data: any) {
    this.showState = true;
    this.states = [];
    this.states = data;
  }

  private _checkStateValue() {
    let state: any = this.registerForm.get('state');
    if (state != null) {
      let value = state.value;
      if (value != '') {
        state.reset();
      }
    }
  }

  private _removeStateInput() {
    let state: any = this.registerForm.get('state');
    this.showState = false;
    if (state != null) {
      this.registerForm.removeControl('state');
    }
  }

  openTerminsAndPolicy(typeOfSheet: number) {
    if (typeOfSheet === 1) {
      this._sheet.open(PrivatePolicyTemplateSheetComponent);
    }
    if (typeOfSheet === 2) {
      this._sheet.open(TerminsAndConditionsTemplateSheetComponent);
    }
    if (typeOfSheet === 3) {
      this._sheet.open(TerminsOfServiceTemplateSheetComponent);
    }
  }

  makeResgisterUser(): void {
    let { type } = environment;
    this._signOnService.user = this.user;
    switch (type) {
      case 'freeplay':
        this._signOnService.registerWithTempCart();
        break;
      case 'nxnoffer':
        this._signOnService.registerWithTempCart();
        break;
      case 'discount-product':
        this._signOnService.registerWithTempCart();
        break;
      case 'discount-vtemplate':
        this._signOnService.registerWithTempCart();
        break;
      case 'casino-freespin':
        this._signOnService.registerFreeSpins();
        break;
      case 'casino-deposit':
        this._signOnService.registerWithTempCart();
        break;
      default:
        console.warn('landing type unexpected');
        break;
    }

    this._signOnService.error$.subscribe((error: RegisterErrorModel) => {
      this.errorMailExist = error.errorMailExist;
      this.loading = error.loading;
      this.isStep = error.isStep;
      this.error = error.useSnackbar;
      this.errorCpfInvalid = error.cpfInvalid;
      this.errorNumberPhone = error.numberPhoneInvalid;
      this.errorInvalidState = error.invalidState;
    });
  }

  resetFlats(): void {
    this.errorMailExist = false;
    this.errorCpfInvalid = false;
    this.errorNumberPhone = false;
    this.errorInvalidState = false;
  }

  removeAccents(input: string): string {
    return input
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  private _availableCountry(): boolean {
    let country: string = this.registerForm.get('country').value;
    let availableCountry = this.countries.find((row) => row.name.toLowerCase() === this.removeAccents(country));

    if (typeof availableCountry === 'object') {
      this.registerForm.get('country').setErrors({ MatchCountry: null });
      this.registerForm.get('country').updateValueAndValidity();
      return true;
    }
    this.registerForm.get('country').setErrors({ MatchCountry: true });
    return false;
  }

  private _availableBirthCountry(): boolean {
    let country: string = this.registerForm.get('country_birth').value;
    let availableCountry = this.birth_countries.find((row) => row.name.toLowerCase() === this.removeAccents(country));

    if (typeof availableCountry === 'object') {
      this.registerForm.get('country_birth').setErrors({ MatchBirthCountry: null });
      this.registerForm.get('country_birth').updateValueAndValidity();
      return true;
    }
    this.registerForm.get('country_birth').setErrors({ MatchBirthCountry: true });
    return false;
  }

  private _availableSSNType(): boolean {
    let ssnTypeControl = this.registerForm.get('ssn_type');
    // Si no existe el control o no hay valor, retorna true (no aplica validación)
    if (!ssnTypeControl || !ssnTypeControl.value) {
      return true;
    }

    let ssnType: string = ssnTypeControl.value;
    if (!this.ssnOptions || !Array.isArray(this.ssnOptions) || this.ssnOptions.length === 0) {
      return false;
    }

    let availableSSNType = this.ssnOptions.find((row) => row.name.toLowerCase() === ssnType.toLowerCase());

    if (typeof availableSSNType === 'object') {
      ssnTypeControl.setErrors({ MatchSSNType: null });
      ssnTypeControl.updateValueAndValidity();
      return true;
    }
    ssnTypeControl.setErrors({ MatchSSNType: true });
    return false;
  }

  redirectToLoginMain(): void {
    this.redirectSrv.redirectToLogin();
  }

  redirecToTerms(): void {
    let parentDomain = this._storageService.getDomainToRedirect();
    const url = `${parentDomain}/help/terms`;
    window.open(url, '_blank');
  }

  onCheckboxChange(e): void {
    this.acceptTerms = e.checked;
  }

  get setClass() {
    return this.country?.iso === 'CO' ? 'box' : 'full-width margin-top-bottom-10';
  }

  ngOnDestroy() {
    this.lottoSubs.unsubscribe();
  }
}
